import { render } from "./ContactInformation.vue?vue&type=template&id=54d1d5d2&ts=true"
import script from "./ContactInformation.vue?vue&type=script&lang=ts"
export * from "./ContactInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__